import { InputAdornment } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import CustomInputLabel from "../customInputLabel";

export default function CustomDatePicker({ value, onChange, label }) {
  const dateValue = value ? dayjs(value) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {label && <CustomInputLabel label={label} />}
      <MobileDatePicker
        // label={label}
        value={dateValue}
        onChange={(newValue) => onChange(newValue)}
        format="DD.MM.YYYY"
        slotProps={{
          textField: {
            variant: "outlined",
            sx: {
              backgroundColor: "#fff",
              borderRadius: "12px",
              width: "100%",
              "& .MuiOutlinedInput-root": {
                padding: "8px",
                "& fieldset": { border: "1px solid #eee", borderRadius: "8px" },
                "&:hover fieldset": {
                  border: "1px solid #eee",
                  borderRadius: "8px",
                },
                "&.Mui-focused fieldset": {
                  border: "1px solid #eee",
                  borderRadius: "8px",
                },
              },
              "& .MuiInputBase-input": {
                fontSize: "16px",
                fontWeight: "500",
                padding: "0 5px",
              },
            },
            InputProps: {
              // startAdornment: (
              //   <InputAdornment position="start">
              //     <img
              //       src={adminIcons.calendarIcon}
              //       style={{ width: "18px" }}
              //       alt="calendar"
              //     />
              //   </InputAdornment>
              // ),
              endAdornment: (
                <InputAdornment position="end">
                  {/* <img
                    src={adminIcons.calendarIcon}
                    style={{ height: "20px" }}
                    alt="dropdown"
                  /> */}
                </InputAdornment>
              ),
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
